import { createContext } from 'react';

const GroupedResponsesContext = createContext({
  pods: [],
  replicaSets: [],
  deployments: [],
  daemonSets: [],
  services: [],
  configMaps: [],
  horizontalPodAutoscalers: [],
  ingresses: [],
  jobs: [],
  cronJobs: [],
  customResources: [],
  statefulsets: []
});

export { GroupedResponsesContext };
//# sourceMappingURL=GroupedResponses.esm.js.map
